import { useCallback, useEffect, useState } from 'react';

const INIT_SELECTED_INDEX = 0;

function useSelectedChapter({ playerRef, timestamps }) {
  const [selectedIndex, setSelectedIndex] = useState(INIT_SELECTED_INDEX);

  const updateSelectedChapter = useCallback(() => {
    const currentTime =
      playerRef.current?.playerRef.current?.currentTime() || 0;
    const lastIndex = timestamps.length - 1;
    if (timestamps[lastIndex] <= currentTime) {
      setSelectedIndex(lastIndex);
      return;
    }
    const currentIndex = timestamps.findIndex(
      (timestamp, index) =>
        timestamp <= currentTime && currentTime < timestamps[index + 1],
    );
    setSelectedIndex(currentIndex);
  }, [playerRef, timestamps]);

  useEffect(() => {
    const id = setInterval(updateSelectedChapter, 1000);
    return () => clearInterval(id);
  }, [playerRef, timestamps, updateSelectedChapter]);

  const checkSelectedChapter = index => selectedIndex === index;

  return { checkSelectedChapter, selectedIndex };
}

export default useSelectedChapter;
